// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as StimulusTabContext$LiteracyplanetTupperware from "./StimulusTabContext.res.mjs";
import * as StimulusToggleContext$LiteracyplanetTupperware from "./StimulusToggleContext.res.mjs";

function PilotStimulusTabContent(props) {
  var showing = Curry._1(StimulusTabContext$LiteracyplanetTupperware.useTabContent, props.tab);
  var match = Curry._1(StimulusToggleContext$LiteracyplanetTupperware.useState, undefined);
  return React.createElement("div", {
              className: match[0] && showing ? "" : "hidden"
            }, props.children);
}

var make = PilotStimulusTabContent;

var $$default = PilotStimulusTabContent;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
